import { ThunkDispatch } from 'redux-thunk';

import { CMSApi } from 'api';
import { PLACEMENT_SCREENS } from 'shared/constants/common';
import { FETCH_PLACEMENTS } from 'shared/store/action-types';
import { createAction } from 'shared/util/utility';

export const fetchPlacements = (screen: PLACEMENT_SCREENS) => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		try {
			const response = await CMSApi.getPlacementData(screen);
			dispatch(
				createAction(FETCH_PLACEMENTS, {
					[screen]: response.data.data.placements,
				}),
			);
		} catch (err) {
			console.error(err);
		}
	};
};
